// src/contexts/IssuesContext.tsx
import React, { createContext, useContext, useState } from 'react';
import { IssueItem } from '../models/issueItem';

interface IssueContextProps {
  selectedIssue: IssueItem | null;
  setSelectedIssue: (issue: IssueItem | null) => void;
}

const IssueContext = createContext<IssueContextProps | undefined>(undefined);

export const useIssue = () => {
  const context = useContext(IssueContext);
  if (!context) {
    throw new Error('useIssue must be used within an IssueProvider');
  }
  return context;
};

export const IssueProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedIssue, setSelectedIssue] = useState<IssueItem | null>(null);

  const value: IssueContextProps = {
    selectedIssue,
    setSelectedIssue,
  };

  return <IssueContext.Provider value={value}>{children}</IssueContext.Provider>;
};

export default IssueContext;
